import * as React from 'react';
import Select from '../select';
import { inject } from 'inversify';
import HttpService from '../../../services/http.service';
import { resolve } from 'inversify-react';
import IdentityService from 'src/services/identity.service';
import FormInput from '../input';
import Tooltip from '../tooltip';
import Icon from '../icon';
import NumberProviderService from 'src/services/number_provider';

export interface EditionComboProps {
    label?: string;
    tooltip?: string;

    editionNumber: number;
    editionCount: number;
    editionType: string;

    minEditionNumber?: number;
    maxEditionNumber?: number;
    minEditionCount?: number;
    maxEditionCount?: number;

    noEditionType?: boolean;
    noEditionNumber?: boolean;

    disabledNumber?: boolean;
    disabledCount?: boolean;
    disabledType?: boolean;

    onChangeEditionNumber: (val) => void;
    onChangeEditionCount: (val) => void;
    onChangeEditionType: (val) => void;
}

export interface EditionComboState {
   letter: string
   type: string
}

export default class EditionCombo extends React.Component<EditionComboProps, EditionComboState> {
  
    @resolve
    editionChar: NumberProviderService;

    constructor(props){
        super(props)

        this.state = {
            letter: 'A',
            type: this.props.editionType
        }
    }

componentDidMount(){
    this.setState({
        letter: this.editionChar.getNumber(this.props.editionNumber),
        type: this.props.editionType
    })
}

    componentWillReceiveProps(nextProps: EditionComboProps){
        if(nextProps.editionType != this.props.editionType){
            console.log(nextProps.editionType)
            this.setState({type: nextProps.editionType})
        }
    }
  public render() {


    return (<div className="edition-combo">
        <div className="edition-combo-label">
            {this.props.tooltip && <Tooltip 
                trigger={<div className='tooltip1 slate'><Icon type='help' style={{cursor: 'pointer'}} /><p> </p></div>}
                content={<p>{this.props.tooltip}</p>}

            />}
            <label className="edition-label">{this.props.label}</label>
        </div>
        <div className="edition-combo-inner">

            {!this.props.noEditionNumber && <FormInput 
                className='edition-number-input'
                type="number"
                value={this.props.editionNumber}
                min={this.props.minEditionNumber}
                max={this.props.maxEditionNumber}
                disabled={this.props.disabledNumber}
                onChange={e => {
                    this.props.onChangeEditionNumber(e)
                    this.setState({letter: this.editionChar.getNumber(e)})
                }}
                />}
            {!this.props.noEditionNumber && this.state.type === 'ap' && <label style={{margin: '10px', marginBottom: '25px'}} className="of">{this.state.letter}</label>}
            {this.state.type !== 'ap' && <label style={{marginBottom: '20px'}} className="of">of</label>}
            {this.state.type !== 'ap' && <FormInput 
                className='edition-count-input'
                type="number"
                min={this.props.minEditionCount}
                max={this.props.maxEditionCount}
                disabled={this.props.disabledCount}
                value={this.props.editionCount}
                onChange={e => this.props.onChangeEditionCount(e)}
            />}
            {!this.state.type && <label style={{marginBottom: '20px'}} className="of">{
                this.state.type === 'ap'? '-':'/'
            }</label>}
            {!this.props.noEditionType && <Select
                keyProperty='id'
                showArrow
                disabled={this.props.disabledType}
                className="edition-select"
                mode={'edit'}
                textProperty='title'
                value={this.props.editionType}
                onChange={e => {
                        this.props.onChangeEditionType(e)
                        this.setState({type: e.id})
                    }
                }
                options={[
                    {
                        id: 'limited',
                        title: 'L. Edition'
                    },{
                        id: 'hc',
                        title: 'HC'
                    },{
                        id: 'ap',
                        title: 'AP'
                    }
                ]}
            />}
        </div>
    </div>)
    
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/data-component/edition-select.tsx